export function delimit(amount = 0, decimals = 2): string {
  return (amount ?? 0).toLocaleString('nl-NL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export default delimit;
